"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestOfferResponseDataSignatureStatusEnum = exports.BestOfferResponseDataStatusEnum = void 0;
exports.instanceOfBestOfferResponseData = instanceOfBestOfferResponseData;
exports.BestOfferResponseDataFromJSON = BestOfferResponseDataFromJSON;
exports.BestOfferResponseDataFromJSONTyped = BestOfferResponseDataFromJSONTyped;
exports.BestOfferResponseDataToJSON = BestOfferResponseDataToJSON;
exports.BestOfferResponseDataToJSONTyped = BestOfferResponseDataToJSONTyped;
var OfferUnderBuyerDto_1 = require("./OfferUnderBuyerDto");
var OfferUnderContractSubjectFinanceDto_1 = require("./OfferUnderContractSubjectFinanceDto");
/**
 * @export
 */
exports.BestOfferResponseDataStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.BestOfferResponseDataSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * Check if a given object implements the BestOfferResponseData interface.
 */
function instanceOfBestOfferResponseData(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('isCounterOffer' in value) || value['isCounterOffer'] === undefined)
        return false;
    if (!('buyer' in value) || value['buyer'] === undefined)
        return false;
    return true;
}
function BestOfferResponseDataFromJSON(json) {
    return BestOfferResponseDataFromJSONTyped(json, false);
}
function BestOfferResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'offerPrice': json['offerPrice'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
        'isCounterOffer': json['isCounterOffer'],
        'buyer': (0, OfferUnderBuyerDto_1.OfferUnderBuyerDtoFromJSON)(json['buyer']),
        'contractSubjects': json['contractSubjects'] == null ? undefined : (json['contractSubjects'].map(OfferUnderContractSubjectFinanceDto_1.OfferUnderContractSubjectFinanceDtoFromJSON)),
        'conditions': json['conditions'] == null ? undefined : json['conditions'],
    };
}
function BestOfferResponseDataToJSON(json) {
    return BestOfferResponseDataToJSONTyped(json, false);
}
function BestOfferResponseDataToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'offerPrice': value['offerPrice'],
        'depositAmount': value['depositAmount'],
        'settlementDate': value['settlementDate'],
        'expiresAt': value['expiresAt'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
        'isCounterOffer': value['isCounterOffer'],
        'buyer': (0, OfferUnderBuyerDto_1.OfferUnderBuyerDtoToJSON)(value['buyer']),
        'contractSubjects': value['contractSubjects'] == null ? undefined : (value['contractSubjects'].map(OfferUnderContractSubjectFinanceDto_1.OfferUnderContractSubjectFinanceDtoToJSON)),
        'conditions': value['conditions'],
    };
}
